const CANDIDATES_LIMIT = 10;

export {
  CANDIDATES_LIMIT,
};
